import React from 'react';
import { BrowserRouter as Router, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import Layout from './pages/Layout';
import {message} from "antd";



const App = () => {

    const PrivateRoutes = (role) => {
        const user = localStorage.getItem('user')
        const status = user ? JSON.parse(user)?.status : false

        // const adminRoutes = [];
        const adminRoutes = [
            '/dashboard/admin/home',
            '/dashboard/admin/historicdata',
            '/dashboard/admin/application',
            '/dashboard/admin/formbuilder'
        ];

        const userRoutes = [
            '/dashboard/user/home',
            '/dashboard/user/historicdata'
        ];


        if (role.role==='admin' && adminRoutes.includes(window.location.pathname)) {
            return <Outlet />
        } else if (role.role==='user' && userRoutes.includes(window.location.pathname)) {
            return <Outlet />
        } else {
            return <Navigate to="/" />
        }

        // if (adminRoutes.includes(window.location.pathname)) {
        //     return <Outlet />
        // } else {
        //     return <Navigate to="/" />
        // }
    }


    return (
        <div>
            <Router>
                <Routes>
                    <Route exact path="/" element={<Login />} />
                    <Route element={<PrivateRoutes role="admin" />}>
                        <Route path="/dashboard/admin/*" element={<Layout />} />
                        {/*<Route path*/}
                    </Route>
                    <Route element={<PrivateRoutes role="user" />}>
                        <Route path="/dashboard/user/*" element={<Layout />} />
                    </Route>
                    <Route exact path="/user/signup" element={<Signup />}/>
                    {/*<Route exact path="/forgot-password" element={<ForgotPassword />}/>*/}
                </Routes>
            </Router>
        </div>

    )

};

export default App;